<template>
  <h2>Something went wrong</h2>
  <h4>{{ error }}</h4>
</template>

<script>
export default {
  props: {
    error: {
      required: false,
    },
  },
};
</script>

<style></style>
